<section class="container section-payment-result">
    <div class="row payment-result-cases pb-5 pt-2">
        <div class="col-md-6 offset-md-3 offset-0 text-center">
            <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
            <h4>Pago completado</h4>
            <p class="mb-1">Tu pago ha sido completado con éxito!.</p>
            <p>Recibirás un email de confirmación con la transacción.</p>
            <a [routerLink]="linkTo" class="btn btn-primary">Volver</a>
        </div>
    </div>
</section>
